import { Keys } from 'excalibur';
import { axis } from './axis';
import { button } from './button';
import { KeyboardLike } from './KeyboardLike';


export const stick = (
    kb: KeyboardLike,
    keys: { left: Keys; right: Keys; up: Keys; down: Keys; press: Keys; }
) => ({
    get x() {
        return axis(kb.isHeld(keys.left), kb.isHeld(keys.right));
    },
    get y() {
        return axis(kb.isHeld(keys.up), kb.isHeld(keys.down));
    },
    get pressed() {
        return button(kb, keys.press);
    },
});
